var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2333 43.2023L56.3066 43.3624L57.2333 43.5224L57.4 44.4557L57.56 43.5224L58.4867 43.3624L57.56 43.2023L57.4 42.269L57.2333 43.2023Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99398 4.55969L4.29395 4.67968L4.99398 4.80635L5.12065 5.50634L5.24064 4.80635L5.94731 4.67968L5.24064 4.55969L5.12065 3.85303L4.99398 4.55969Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0467 66.0001C57.3641 66.0001 60.0534 63.3111 60.0534 59.994C60.0534 56.677 57.3641 53.988 54.0467 53.988C50.7293 53.988 48.04 56.677 48.04 59.994C48.04 63.3111 50.7293 66.0001 54.0467 66.0001Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0466 62.3877C55.3684 62.3877 56.44 61.3162 56.44 59.9944C56.44 58.6726 55.3684 57.6011 54.0466 57.6011C52.7248 57.6011 51.6533 58.6726 51.6533 59.9944C51.6533 61.3162 52.7248 62.3877 54.0466 62.3877Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.367 66.0001C15.6844 66.0001 18.3737 63.3111 18.3737 59.994C18.3737 56.677 15.6844 53.988 12.367 53.988C9.04963 53.988 6.36035 56.677 6.36035 59.994C6.36035 63.3111 9.04963 66.0001 12.367 66.0001Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.367 62.3877C13.6888 62.3877 14.7603 61.3162 14.7603 59.9944C14.7603 58.6726 13.6888 57.6011 12.367 57.6011C11.0452 57.6011 9.97363 58.6726 9.97363 59.9944C9.97363 61.3162 11.0452 62.3877 12.367 62.3877Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1338 62.487H63.1871C64.8538 59.6473 63.6738 56.5943 63.6738 56.5943C64.0205 51.4682 57.1405 50.635 48.2671 49.8084L41.0471 42.9091C40.1938 42.0958 39.0671 41.6426 37.8871 41.6426H13.1871C11.6071 41.6426 10.1405 42.4558 9.30714 43.8023L5.57382 49.8084C2.95382 50.215 2.90714 53.0814 2.60047 55.3478C2.42714 56.6076 2.25382 58.4874 2.11382 60.0006C1.99382 61.3405 3.04713 62.487 4.38713 62.487H5.26714",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4541 62.4871H46.9541",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6734 56.6016C60.8267 56.3016 60.6601 54.0616 61.5934 52.7283",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4541 49.8086H48.2674",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57324 49.8086H40.3466",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6475 51.1616V62.4138",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4199 41.7229L42.1066 47.8162",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4463 47.9622H42.4663C43.4863 47.9622 44.3129 48.7889 44.3129 49.8089C44.3129 50.8289 43.4863 51.6556 42.4663 51.6556H40.4463V47.9556V47.9622Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4873 41.7827V62.3206",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.694 52.4016H25.7939",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 52.4016H29.7334",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91309 54.3886C5.78642 54.3886 6.49979 51.6686 5.57312 49.8086",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02637 16.4519H61.973",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02637 34.59V16.4519H61.973V34.59",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0464 34.5898H1.95312",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97949 29.1704V19.8647H16.0995V29.1704",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.04 19.8647V29.1704",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97949 24.5176H16.0995",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5596 29.1704V19.8647H55.6796V29.1704",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6201 19.8647V29.1704",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5596 24.5176H55.6796",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6601 29.1704H8.42676",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2334 29.1704H48",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 22.2778H29.2266V34.5898H36.6999V22.2778Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7197 34.59V16.4519",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2803 34.59V16.4519",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3066 19.7449H39.62",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7197 27.1372V28.7838",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3066 37.0229H39.62",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2797 16.452L32.9997 6.28638L22.7197 16.452",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65 17.1984L33 2L1 17.1984",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0264 7.16623V3.16626",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7402 10.0655V3.16626",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5068 3.1665H53.2602",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseMobile);
export default __webpack_public_path__ + "static/media/house_mobile.a648992dd11e153baf8688a50a48dc42.svg";
export { ForwardRef as ReactComponent };